export default __webpack_public_path__ + "static/media/PinkPlayerCheeringMin.1d2e7eab.png";